export function concat<T extends Array<unknown>>(target: T, source: T): void {
  for (let i = 0; i < source.length; i++) {
    target.push(source[i]);
  }
}
